import { BaseModule } from "./base.module";
import * as QRCode from 'qrcode';

export class QRCodeGeneratorModule extends BaseModule {
    doGenerateHrefQRCode = false;
    initialize() {
        this.generateHrefQRCode();
    }

    generateHrefQRCode(data = `${window.location.href}`) {
        if (typeof QRCode !== 'undefined') {
            // this.qrCodeWriteCanvas
            if (this.doGenerateHrefQRCode == true && window && window.location && window.location.pathname) {
                this.generate(data);
            }
        }
    }
    
    generate(data) {
        let qrCodeWriteCanvas = document.createElement('canvas');
        qrCodeWriteCanvas.height = 100;
        qrCodeWriteCanvas.width = 100;
        QRCode.toCanvas(qrCodeWriteCanvas, `${data}`, (...spreadArguments) => {
            console.log('QR code was written to. This is the canvas object:', qrCodeWriteCanvas);
            console.log('and spreadArguments is', spreadArguments);
        });
        document.documentElement.insertAdjacentElement('beforeend', qrCodeWriteCanvas);
    }
}